import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import TemplateHeader from "template-store/components/template-header/template-header";
import { getPlatformAddSolutionLink } from "/constants/links";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getCategoriesData } from "template-store/services/solution-categories-service";
import TemplatePageTabs from "template-store/components/template-page-tabs/template-page-tabs";
import { SIGN_UP_WITH_TEMPLATE_CLICKED } from "constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { getSolutionEnglishName } from "template-store/services/solution-data-service";
import { StyledDesktopTemplatePageContent } from "./desktop-template-page-content.scss";
const DesktopTemplatePageContent = (props)=>{
    const { template, templateId, translate, allCategories, tabsMetadata } = props;
    const templateData = template === null || template === void 0 ? void 0 : template.data;
    const onUseTemplateClickAction = useCallback(()=>{
        trackEvent(SIGN_UP_WITH_TEMPLATE_CLICKED, {
            kind: templateId,
            info1: getSolutionEnglishName(template)
        });
    }, [
        template,
        templateId
    ]);
    return /*#__PURE__*/ _jsxs(StyledDesktopTemplatePageContent, {
        className: "desktop-template-page-content-component",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "template-top-section-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "header-wrapper",
                        children: /*#__PURE__*/ _jsx(TemplateHeader, {
                            templateName: templateData === null || templateData === void 0 ? void 0 : templateData.name,
                            templateCategoriesData: getCategoriesData(allCategories, templateData === null || templateData === void 0 ? void 0 : templateData.categories),
                            categoriesPrefixText: translate("templateCenter.category.idealFor")
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "button-wrapper",
                        children: /*#__PURE__*/ _jsx(RegularButton, {
                            buttonText: translate("templateCenter.template.useTemplate"),
                            url: getPlatformAddSolutionLink(templateId),
                            isOpenLinkInNewTab: true,
                            onClick: onUseTemplateClickAction
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "template-description-wrapper",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "template-description",
                    children: [
                        " ",
                        templateData === null || templateData === void 0 ? void 0 : templateData.description
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "template-page-tabs-wrapper",
                children: /*#__PURE__*/ _jsx(TemplatePageTabs, {
                    templateData: templateData,
                    tabsMetadata: tabsMetadata
                })
            })
        ]
    });
};
DesktopTemplatePageContent.defaultProps = {};
export default withGenericConfig(DesktopTemplatePageContent);
